<ng-template #view>
  <ng-content select="[viewContent]"></ng-content>
</ng-template>

<ng-template #edit>
  <ng-content select="[editContent]"></ng-content>
</ng-template>

<ng-template #shared>
  <ng-content/>
</ng-template>

@if (isEditing()) {
  <ng-container [ngTemplateOutlet]="edit"/>
  <ng-container [ngTemplateOutlet]="shared"/>

  @if (editMode() === 'manual') {
    <div class="app-row-auto {{align()}}">
      <button type="button" title="Save" [disabled]="!valid()" class="transparent text-success" (click)="save()">
        <icon type="save"/>
      </button>
      <button type="button" title="Cancel" class="transparent text-danger" (click)="cancel()">
        <icon type="cancel"/>
      </button>
    </div>
  }
} @else {
  <ng-container [ngTemplateOutlet]="view"/>
  <ng-container [ngTemplateOutlet]="shared"/>

  <button type="button"
          title="Edit"
          [class.invisible]="editMode() === 'never'"
          class="transparent {{align()}}"
          (click)="isEditing.set(true)"
  >
    <icon type="edit"/>
  </button>
}
